import React, { Component, Fragment, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import TagManager from 'react-gtm-module';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import LocalRedirect from '../components/LocalRedirect';
import PaymentMethods from '../components/PaymentMethods';
import PaymentSharedFields from '../components/PaymentSharedFields';
import PaymentSubmitButton from '../components/PaymentSubmitButton';
import { selectedSeatsHumanSelector } from '../selectors/index';
import Movie from '../components/Movie';
import Return from '../components/Return';
import { resetTime, routeChanged, setStartTime } from '../store/globals';
import { resetOrder } from '../store/order';
import { requestAnnualPassPayment, requestBankCard, requestCineCashPayment, requestMovieYelmoPayment, requestBizumOrder, requestRedsysOrder, requestPaypalOrder, requestPriceZeroPayment, requestReservation, requestVisaCheckout, requestVisaCheckOutDecrypt, setPaymentType, setSessionId, setTokenRecaptcha, paymentRequest, requestSpreedly, clearPaymentResponse, loadingFormPayment } from '../store/payments';
import { hideModal } from '../store/ui';
import localSessionStorage from '../services/localSessionStorage';

import {getBizumService, getRedsysService} from '../services';


class Payments extends Component {

  constructor(props) {
    super(props);

    this.recaptchaRef = React.createRef();
    let initialBillTo = {
      email: '',
      first_name: '',
      last_name: '',
      full_name: '',
      loyalty: '',
      tarjeta_my: '' 
    };

    if (this.props.loginResponse !== null) {
      const { email, first_name, last_name, full_name, card_number } = this.props.loginResponse;

      initialBillTo = {
        email, first_name, last_name, full_name, loyalty: card_number
      };
    }
    this.state = {
      active: false,
      mobilePaymentMethodsOpen: props.isMobile && props.wSize < 680 ? false : null,
      bill_to: initialBillTo,
      valid: false,
      tokenRecaptcha: '',
      hideButtons: false,
      itemPrice: false,
      itemQuantity: false,
      annualPassCategory: 0,
    };

    
  }

  componentDidMount() {
    this.props.resetOrder(this.props.sessionId, false);
    this.props.setSessionId(this.props.sessionId);
    this.props.setPaymentType(this.state.active);
    const tagManagerArgs = {
      dataLayer: {
        item_name: this.props.movieName,
        event: 'pago',
        items: [{
          step: 3,
          action: "checkout"
        }]
      }
    }
    const tagManagerPageView = {
      dataLayer: {
        item_name: this.props.movieName,
        event: "pageView",
        path: '/visPayment'
      }
    }

    TagManager.dataLayer(tagManagerArgs);
    TagManager.dataLayer(tagManagerPageView);    

    let total = this.props.total / 100;
    window.requestVisaCheckOutDecrypt = this.props.requestVisaCheckOutDecrypt;
    window.onVisaCheckoutReady = function onVisaCheckoutReady() {
      window.V.init({
        apikey: process.env.REACT_APP_CNPL_PURCHASE_API_KEY_VC,
        paymentRequest: {
          currencyCode: 'EUR',
          subtotal: total,
          total: total
        }
      });
      window.V.on('payment.success', function (payment) {
        window.requestVisaCheckOutDecrypt(payment.encPaymentData, payment.encKey, payment.callid);
      });
      window.V.on('payment.cancel', function (payment) { });
      window.V.on('payment.error', function (payment, error) { });
    };

    if (typeof this.props.payments.paymentResponse.url !== 'undefined' || (typeof this.props.payments.paymentResponse.tickets_confirmation !== 'undefined' && this.props.payments.paymentResponse.tickets_confirmation !== null && this.props.payments.paymentResponse.tickets_confirmation.status > 0)) {
      this.props.clearPaymentResponse();
      this.props.hideModal();
    }
    const { ticket  } = this.props;
    let caterogories = '';
    let i = 0;
    for (let item of ticket.selectedTickets) {
      let category = '';
      for (let areaItem of ticket.tickets.areas) {
        let area = areaItem.tickets.find(c => c.code === item.ticket_type_code);
        if (typeof area !== 'undefined') {
          caterogories += caterogories !== '' ? ', ' + (typeof area.description !== 'undefined' ? area.description : typeof area.name !== 'undefined' ? area.name : '') : '';
          category = area.description;
          category.includes("PASE") || area.is_folio ? i++ : i = i + 0; 
        }
      } 
    }
    this.setState({ annualPassCategory: i });
  }

  shouldComponentUpdate(prevProps, prevState) {
    if (
      prevState.active === this.state.active &&
      JSON.stringify(prevState.bill_to) === JSON.stringify(this.state.bill_to) &&
      prevState.valid === this.state.valid &&
      prevProps.payments.paymentResponse === this.props.payments.paymentResponse &&
      prevProps.payments.isLoading === this.props.payments.isLoading &&
      prevProps.withFolio === this.props.withFolio &&
      prevProps.isMobile === this.props.isMobile &&
      prevProps.modal === this.props.modal &&
      prevState.mobilePaymentMethodsOpen === this.state.mobilePaymentMethodsOpen &&
      prevState.annualPassCategory === this.state.annualPassCategory &&
      prevState.loginResponse === this.props.loginResponse
    ) {
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.payments.type !== this.state.active)
      this.props.setPaymentType(this.state.active);
    if (this.state.active === 'bank_card') { // credit card
      this.isCreditCardValid();
    } else if (this.state.active === 'loyalty_tickets') {
      this.isMovieYelmoValid();
    } else if (['unpaid_booking', 'paypal_tickets', 'visa_checkout', 'cinecash', 'price-zero', 'spreedly_tickets', 'bizum_tickets', 'redsys_tickets'].indexOf(this.state.active) > -1) { // every other payment type
      this.isPaymentMethodValid();
    }

    if (prevProps.payments.isLoading !== this.props.payments.isLoading && this.props.payments.isLoading && this.state.valid) {
      window.scrollTo(0, 0);
    }

    if (prevProps.loginResponse !== this.props.loginResponse && this.props.loginResponse !== null
      && this.props.loginResponse.access_token !== null) {

      const { email, first_name, last_name, full_name, card_number } = this.props.loginResponse;
      this.setState({
        bill_to: { email, first_name, last_name, full_name, loyalty: card_number }
      });
    }
    if (this.state.active === 'visa_checkout' && this.props.payments.visaCheckoutDecryptResponse !== null && !this.props.payments.isLoading && typeof this.props.payments.paymentResponse.tickets_confirmation === 'undefined') {
      if (typeof this.props.payments.visaCheckoutDecryptResponse.card !== 'undefined' && this.props.payments.visaCheckoutDecryptResponse.card !== null) {
        var cinema = {
          name: this.props.cinemaName,
          position: {
            latitude: this.props.cinemaLat,
            longitude: this.props.cinemaLng
          }
        };
        const fingerprintId = this.props.cinema_id + '_' + this.props.sessionId;
        var movie = {
          name: this.props.movieName,
          duration: this.props.movieDuration,
          format: this.props.movieFormat
        };
        this.props.requestVisaCheckout(this.props.payments.visaCheckOutData,
          this.props.payments.visaCheckOutWrappedKey,
          this.state.bill_to,
          this.props.payments.visaCheckOutCallId,
          this.props.payments.visaCheckoutDecryptResponse.card,
          cinema,
          fingerprintId,
          this.state.bill_to.loyalty,
          movie,
          this.props.sessionId);
      }
    }
  }

  componentWillUnmount() {
    var vco = document.getElementById('vcop-src-frame');
    if (vco !== null && typeof vco !== 'undefined')
      vco.parentNode.removeChild(vco);
  }

  handleActiveForm = (active) => {
    if (this.state.active === active) return;
    this.setState((prevState, props) => {
      return {
        active,
        bill_to: {
          first_name: prevState.bill_to.first_name,
          last_name: prevState.bill_to.last_name,
          full_name: prevState.bill_to.first_name + ' ' + prevState.bill_to.last_name,
          email: prevState.bill_to.email,
          loyalty: prevState.bill_to.loyalty,
          tarjeta_my: prevState.bill_to.tarjeta_my,
          accept_terms: prevState.bill_to.accept_terms ? prevState.bill_to.accept_terms : false
        },
        valid: false,
        mobilePaymentMethodsOpen: props.isMobile && props.wSize < 680 ? true : null,
        tokenRecaptcha: ''
      };
    });

    if (this.props.modal !== null && this.props.modal.position === 'main') {
      this.props.hideModal();
    }
  };

  handleOpenMobileMethods = () => {
    this.setState({ mobilePaymentMethodsOpen: false });
  };

  handleInputChange = (name, value, valid) => {
    const bill_to = { ...this.state.bill_to };

    if (valid) {
      bill_to[name] = value;
      this.setState({ bill_to });
    } else if (value === '' || !value) {
      bill_to[name] = value;
      this.setState({ bill_to, valid: false });
    } else {
      this.setState({ valid: false });
    }
  };

  isSharedFieldsValid() {
    const { first_name, last_name, email, full_name } = this.state.bill_to;
    return first_name !== '' && last_name !== '' && email !== '' && full_name !== '';
  }

  isCheckboxValid() {
    return this.state.bill_to.hasOwnProperty('accept_terms') &&
      this.state.bill_to['accept_terms'] && !this.state.valid
  }

  isDefaultFieldsValid() {
    if (this.isSharedFieldsValid() && this.isCheckboxValid()) {
      return true;
    }

    return false;
  }

  isPaymentMethodValid() {
    if (this.isDefaultFieldsValid()) {
      this.setState({ valid: true });
    }
  }

  isCreditCardValid() {
    const { bill_to } = this.state;

    if (
      this.isDefaultFieldsValid() &&
      bill_to.hasOwnProperty('card_number') && bill_to.card_number !== '' &&
      bill_to.hasOwnProperty('card_name') && bill_to.card_name !== '' &&
      bill_to.hasOwnProperty('card_date') && bill_to.card_date !== '' &&
      bill_to.hasOwnProperty('card_cvv') && bill_to.card_cvv !== ''
    ) {
      this.setState({ valid: true });
    }
  }

  isMovieYelmoValid() {
    const { bill_to } = this.state;

    if (
      this.isDefaultFieldsValid() &&
      bill_to.hasOwnProperty('card_cc_number') && bill_to.card_cc_number !== '' &&
      bill_to.hasOwnProperty('cc_pin') && bill_to.cc_pin !== ''
    ) {
      this.setState({ valid: true });
    }
  }
  recieveMessage = (event) => {
    try {
      var data = JSON.parse(event.data);
      if (typeof data.token !== 'undefined' && typeof data.number !== 'undefined') {
        var fingerprintId = this.props.cinema_id + '_' + this.props.sessionId;
        this.props.requestSpreedly(this.state.bill_to, this.props.sessionId, fingerprintId, data.token, this.state.tokenRecaptcha, data.first_six_digits);
        this.props.hideModal();
      }
    } catch (e) {
    }
  }
  handleSubmit = () => {
    const tokenR = this.recaptchaRef.current.getValue();

    let metodo = '';
    let paymentData = {
      payment: '',
      country : '',
      loyalty : '',
      paymentType : '',
      merchantOrderId : '',
      billTo : {
        first_name: this.state.bill_to.first_name,
        last_name: this.state.bill_to.last_name,
        full_name: this.state.bill_to.first_name + ' ' + this.state.bill_to.last_name,
        email: this.state.bill_to.email,
        loyalty: this.state.bill_to.tarjeta_my ? this.state.bill_to.tarjeta_my.replace(/ /g,'') : this.state.bill_to.loyalty,
        accept_terms: this.state.bill_to.accept_terms ? this.state.bill_to.accept_terms : false
      },
    }
    
 if (this.state.active === 'bizum_tickets') {
      metodo = 'bizum';
      const payment_type = "tickets";
      const country_code = "ES";
      this.props.loadingFormPayment();
      getBizumService(country_code, this.props.sessionId, this.props.showtimeVistaId, this.props.cinema_id, paymentData.billTo.loyalty, payment_type, paymentData.billTo, tokenR, this.props.clubCarrefour).then((response) => {
        const realResponse = response.data;
        const form_bizum = document.createElement("form");
        this.setState({ tokenRecaptcha: tokenR });
        paymentData = {
          payment : this.state.active,
          country : country_code,
          loyalty : paymentData.billTo.loyalty,
          paymentType : payment_type,
          merchantOrderId : realResponse.merchant_order_id,
          billTo : paymentData.billTo,
          clubCarrefour: this.props.clubCarrefour
        }
        localSessionStorage.set('order-data', paymentData);
        form_bizum.setAttribute("action", realResponse.request_url);
        form_bizum.setAttribute("method", "POST");
  
        realResponse.parameters.map(field => {
          const input_bizum_form = document.createElement("input");
          input_bizum_form.setAttribute("type","hidden");
          input_bizum_form.setAttribute("name",field.name);
          input_bizum_form.setAttribute("value",field.value);
          form_bizum.appendChild(input_bizum_form);
        });
        document.body.appendChild(form_bizum);
        form_bizum.submit();
      }); 
    }else if (this.state.active === 'redsys_tickets') {
     //cambiar cuando food se añada
     const payment_type = "tickets";
     const country_code = "ES";
     this.setState({ tokenRecaptcha: tokenR });
     metodo = 'redsys';
     this.props.loadingFormPayment();
     getRedsysService(country_code, this.props.sessionId, this.props.showtimeVistaId, this.props.cinema_id, paymentData.billTo.loyalty, payment_type, paymentData.billTo, tokenR, this.props.clubCarrefour).then((response) => {
       const realResponse = response.data;
       const form_bizum = document.createElement("form");

       paymentData = {
        payment : this.state.active,
        country : country_code,
        loyalty : paymentData.billTo.loyalty,
        paymentType : payment_type,
        merchantOrderId : realResponse.merchant_order_id,
        billTo : paymentData.billTo,
        clubCarrefour: this.props.clubCarrefour
      }
      localSessionStorage.set('order-data', paymentData);
       form_bizum.setAttribute("action", realResponse.request_url);
       form_bizum.setAttribute("method", "POST");
 
       realResponse.parameters.map(field => {
         const input_bizum_form = document.createElement("input");
         input_bizum_form.setAttribute("type","hidden");
         input_bizum_form.setAttribute("name",field.name);
         input_bizum_form.setAttribute("value",field.value);
         form_bizum.appendChild(input_bizum_form);
       });
       document.body.appendChild(form_bizum);
       form_bizum.submit();
     }); 
    } else if (this.state.active === 'unpaid_booking') { // reservation            
      metodo = 'reservation';
      this.props.requestReservation(this.state.bill_to, this.props.sessionId, tokenR);
    } else if (this.state.active === 'cinecash') {
      metodo = 'cinecash';
      const { access_token } = this.props.loginResponse;
      this.props.requestCineCashPayment(this.state.bill_to, this.props.sessionId, access_token, this.props.cinemaName, this.props.movieName, this.state.bill_to.loyalty, tokenR);
    } else if (this.state.active === 'loyalty_tickets') {
      metodo = 'club cinépolis';
      let card_number = this.state.bill_to.loyalty;
      if (typeof this.state.bill_to.card_cc_number !== 'undefined')
        card_number = this.state.bill_to.card_cc_number;

      this.props.requestClubCinepolisPayment(this.state.bill_to,
        this.props.sessionId,
        this.state.bill_to.cc_pin,
        card_number, tokenR);
    } else if (this.state.active === 'price-zero') {
      metodo = 'price-zero';
      this.props.requestPriceZeroPayment(this.state.bill_to, this.props.sessionId, tokenR);
    }
    this.recaptchaRef.current.reset();

    const { showtime, ticket, textselectedSeats } = this.props;

    let products = [];
    const beginCheckoutEventItems = []
    let i = 1;
    let caterogories = '';
    for (let item of ticket.selectedTickets) {
      let category = '';
      let price;
      for (let areaItem of ticket.tickets.areas) {
        let area = areaItem.tickets.find(c => c.code === item.ticket_type_code);
        if (typeof area !== 'undefined') {
          caterogories += caterogories !== '' ? ', ' + (typeof area.description !== 'undefined' ? area.description : typeof area.name !== 'undefined' ? area.name : '') : '';
          category = area.description;
          price = area.price / 100
        }
      }
      this.setState({ itemPrice: price, itemQuantity: item.quantity});
      let product = {
        item_id: i.toString() + ticket.tickets.session_id + showtime.showtimes.datetime.split('T')[1].replace(/:/g, ""),
        item_name: showtime.movie.name.replace(` ${showtime.movie.format}`,''),
        item_brand: showtime.movie.distributor, //distribuidora 
        item_category: "boleto",
        item_category2: category,
        item_category3: "NA",
        item_category4: "NA",
        item_variant: showtime.cinema.name,
        seat: textselectedSeats,
        Language: showtime.movie.language,
        price: price,
        quantity: item.quantity,
        item_sala: showtime.movie.format
      };

      beginCheckoutEventItems.push({
        item_id: i.toString() + ticket.tickets.session_id + showtime.showtimes.datetime.split('T')[1].replace(/:/g, ""),
        item_name: showtime.movie.name.replace(` ${showtime.movie.format}`,''),
        item_brand: showtime.movie.distributor,
        item_category: "boleto",
        item_category2: category,
        item_cinema: showtime.cinema.name,
        seat: textselectedSeats,
        item_city: this.props.cityName,
        movie_date: showtime.showtimes.datetime.split('T')[0].replaceAll("-", " "),
        movie_time: showtime.showtimes.datetime.split('T')[1],
        item_language: showtime.movie.language,
        price: price,
        quantity: item.quantity,
        payment_method: metodo,
        item_age: showtime.movie.rating,
        item_sala: showtime.movie.format
      })
      products.push(product);
      i++;
    }

    let currentTime = new Date();
    let horas = currentTime.getHours();
    let minutos = currentTime.getMinutes();
    let segundos = currentTime.getSeconds();
    let timeNow =(`${horas}:${minutos}:${segundos}:`);

    const beginCheckoutEventArgs = {
      dataLayer: {
        event: 'begin_checkout',
        ecommerce:{
          currency: "EUR",
          times: timeNow,
          value: this.state.itemPrice * this.state.itemQuantity, 
          items: [beginCheckoutEventItems]
        }
      }
    }

    const tagManagerArgs2 = {
      dataLayer: {
        event: "add_payment_info",
        ecommerce: {
          currency: "EUR",
          value: this.props.total / 100,
          coupon: this.props.folio ? this.props.folio : '',
          payment_type: this.state.active ? this.state.active : '',
          items: [...products]
        }
      }
    }

    TagManager.dataLayer(beginCheckoutEventArgs);
    TagManager.dataLayer(tagManagerArgs2)

    this.setState({ hideButtons: true });
  }

  handleRecaptcha = (e) => {
    e.preventDefault();

    if (this.state.valid)
      this.recaptchaRef.current.execute();
  }

  getReturnRoute = () => {
    const { hasSeats } = this.props;
    if (hasSeats) {
      return '/butacas';
    } else {
      return '/entradas';
    }
  }

  positionBtnPayment = () => {
    const aside = document.querySelectorAll('.main-aside__body');
    if(aside.length){
      return aside[0].offsetHeight - 125;
    }
    return 160;
  }

  render() {
    const { withFolio, modal, isMobile, wSize, loginResponse } = this.props;
    const { isLoading, paymentResponse } = this.props.payments;

    if (typeof paymentResponse.tickets_confirmation !== 'undefined' && paymentResponse.tickets_confirmation !== null && typeof paymentResponse.tickets_confirmation.status !== 'undefined') {
      if (paymentResponse.tickets_confirmation.status === 0)
        return <LocalRedirect to="/confirmacion" />;
    }

    return (
      <Fragment>
        {this.props.isMobileOrDesktop && !isLoading && <Return to={this.getReturnRoute()} />}
        {this.props.isMobile && <Movie />}

        <form onSubmit={this.handleRecaptcha} autoComplete="off">
          <div className="container container--mid-large payments">
            {isLoading ? <Loader text="" /> :
              <div className={`${this.state.valid && isLoading ? 'blur-overlay' : ''}`}>
                <PaymentSharedFields
                  bill_to={this.state.bill_to}
                  onInputChange={this.handleInputChange}
                  onInputBlur={this.handleInputBlur}
                  updateValue={loginResponse !== null && loginResponse.access_token !== null}
                  active={this.state.active}
                  isLoyalty={this.props.isLoyalty}
                  annualPassCategory={this.state.annualPassCategory>=1 }
                />

                <PaymentMethods
                  active={this.state.active}
                  isMobile={isMobile && wSize < 680}
                  mobilePaymentMethodsOpen={this.state.mobilePaymentMethodsOpen}
                  handleActiveForm={this.handleActiveForm}
                  onInputChange={this.handleInputChange}
                  onInputBlur={this.handleInputBlur}
                  onSubmit={this.handleInputs}
                  onChangeMobileMethods={this.handleOpenMobileMethods}
                  modal={this.props.modal}
                  disabled={this.props.paymentMethodsDisabled}
                  terms={this.props.terms}
                  privacy_policy={this.props.privacy_policy}
                  paymentMethodsSettings={this.props.paymentMethodsSettings}
                  isPriceZero={this.props.isPriceZero}
                  isLoyalty={this.props.isLoyalty}
                  isAnnualPass={this.props.isAnnualPass}
                  accept_terms={this.state.bill_to.accept_terms}
                  hasFolio={this.props.hasFolio}
                />
              </div>
            }
            <ReCAPTCHA
              ref={this.recaptchaRef}
              size="invisible"
              sitekey="6LcVRncgAAAAAIki4zbiiTYFCUNkbrcLAyqqxOhi"
              onChange={this.handleSubmit}
            />

            <div
              className={`payments__submit${withFolio !== null ? ' extra-top' : ''}${modal !== null && modal.position === 'aside' ? ' blur-overlay' : ''}`}
              Style={`top: ${this.positionBtnPayment()}px`}
            >
              {this.state.active !== 'visa_checkout' && !isLoading &&
                <PaymentSubmitButton
                  isMobile={!this.props.isMobileOrDesktop}
                  wSize={wSize}
                  isPaymentLoading={isLoading}
                  active={this.state.active}
                  valid={this.state.valid}
                />
              }              

              <img alt="Visa Checkout" className={`v-button${this.state.active === 'visa_checkout' && this.state.valid ? ' active' : ''}`} role="button" hidden={this.state.valid && this.state.active === 'visa_checkout' ? `none` : `hidden`}
                src="https://secure.checkout.visa.com/wallet-services-web/xo/button.png" />
              {!this.props.isMobileOrDesktop &&
                <img alt="Visa Checkout" className={`v-button v-button__header${this.state.active === 'visa_checkout' && this.state.valid ? ' active' : ''}`} role="button" hidden={this.state.valid && this.state.active === 'visa_checkout' ? `none` : `hidden`}
                  src="https://secure.checkout.visa.com/wallet-services-web/xo/button.png" />
              }
            </div>

            {!isLoading && <div className={`payments__disclaimer${modal !== null && modal.position === 'aside' ? ' blur-overlay' : ''}`}>
              <p className="text text--small">Por favor, revisa la película, fecha, sesión y verifica que la información mostrada en el Resumen de Compra corresponde a la que has seleccionado, ya que, no se podrá hacer cambios ni devoluciones una vez finalizada la transacción. Si necesitas modificar tu compra, puedes usar el botón volver.</p>
            </div>}
          </div>
        </form>

        {!this.props.isMobileOrDesktop && !isLoading && <Return to={this.getReturnRoute()} />}
      </Fragment>
    );
  }
}


const mapStateToProps = ({ ui, payments, globals, login, showtime, tickets, cards, seats, locations }) => {
  const onlyAdultTickets = tickets.selectedTickets.filter(({ type }) => type.toLowerCase().includes("adulto")).length === tickets.selectedTickets.length

  let cityName = ''
  if(locations && locations.cities) {
    const currentCity = locations.cities.find(city => {
      const hasCurrentCinema = city?.cinemas.find(cinema => cinema.vista_id === showtime.cinema.vista_id)
      return hasCurrentCinema
    })
    cityName = currentCity?.name
  }

  return {
    sessionId: globals.sessionId,
    showtimeVistaId: globals.showtimeVistaId,
    isMobile: ui.isMobile,
    wSize: ui.size,
    modal: ui.modal,
    movieName: showtime.movie.name,
    movieFormat: showtime.movie.language,
    movieDuration: showtime.movie.length,
    cinemaName: showtime.cinema.name,
    cinemaLat: showtime.cinema.lat,
    cinemaLng: showtime.cinema.lng,
    loginResponse: login.loginResponse,
    cinema_id: showtime.cinema.vista_id,
    paymentMethodsDisabled: showtime.showtimeInfo !== null && typeof showtime.showtimeInfo.payment_methods_disabled !== 'undefined' ? showtime.showtimeInfo.payment_methods_disabled : [],
    movieDistributor: showtime.distributor,
    terms: showtime.settings.purchases.terms,
    privacy_policy: showtime.settings.purchases.privacy_policy,
    paymentMethodsSettings: showtime.settings.payment_methods,
    withFolio: cards.folio !== null,
    isLoyalty: cards.folio !== null && typeof cards.folio.type !== 'undefined' && cards.folio.type !== 'loyalty',
    isAnnualPass: cards.folio !== null && (cards.folio.parent_code === 'pase-anual'),
    isPriceZero: tickets.total === 0,
    total: seats.seatsSelectedResponse.total_value,
    selectedTickets: tickets.selectedTickets,
    payments,
    concessions: seats.concessions_data,
    bookingFee: typeof seats.seatsSelectedResponse.booking_fee_value !== 'undefined' ? seats.seatsSelectedResponse.booking_fee_value : 0,
    isMobileOrDesktop: (ui.isMobile && ui.size >= 768 && ui.size < 1024) || !ui.isMobile,
    merchantId: locations.merchantId,
    hasSeats: seats.hasSeats,
    hasFolio: tickets.selectedTickets.some(ticket => ticket.folio !== null),
    clubCarrefour: (onlyAdultTickets && cards.folio?.type === 'club-carrefour') ? cards.folio.number : '',
    folio: cards.folio?.parent_code,
    textselectedSeats: selectedSeatsHumanSelector({
      ui,
      payments, globals, tickets, seats, showtime
    }),
    showtime,
    cityName,
    ticket: tickets
  };
};

export default connect(
  mapStateToProps,
  {
    requestReservation, setSessionId, setStartTime,
    resetOrder, resetTime, routeChanged, hideModal,
    requestBankCard, requestCineCashPayment, requestMovieYelmoPayment, requestPaypalOrder, requestBizumOrder, requestRedsysOrder, requestVisaCheckOutDecrypt, requestVisaCheckout, setTokenRecaptcha, requestAnnualPassPayment, requestPriceZeroPayment, setPaymentType, paymentRequest, requestSpreedly, clearPaymentResponse, getBizumService, getRedsysService, loadingFormPayment
  }
)(Payments);

